module.exports = __webpack_public_path__ + "static/img/nr1-4.bc969bf.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/nr1-4.png
// module id = 409
// module chunks = 0